import { Component } from '@angular/core';

@Component({
  selector: 'app-root-placeholder',
  standalone: true,
  template: ''
})
export class RootPlaceholderComponent {}
